import loadNotificationsLogic from "./loadNotificationsLogic";
import loadNotificationsFailLogic from "./loadNotificationsFailLogic";

export default [...loadNotificationsLogic, ...loadNotificationsFailLogic];
